var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Calendar',{attrs:{"showTime":false,"selectOtherMonths":true,"locale":_vm.sv,"dateFormat":"yy-mm-dd"},model:{value:(_vm.theDate),callback:function ($$v) {_vm.theDate=$$v},expression:"theDate"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428a82a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vfg-custom-fields/fieldDatePicker.vue
// module id = null
// module chunks = 